import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_GITLAB_STATUS,
} from './gitlabTypes'

export default (state, action) => {
    switch (action.type) {
        case GET_GITLAB_STATUS:
            return {
                ...state,
                gitlab_status: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
